module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar buttonColorClass = '';\nif(model.buttonColor) buttonColorClass = model.buttonColor.data;\nif (model.buttonText){\n%>\n<button class=\"<%- buttonColorClass %>\"><%= model.buttonText %></button>\n<%\n}\n%>"
  , __filename = "components/mobile/button/button.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var buttonColorClass = '';
if(model.buttonColor) buttonColorClass = model.buttonColor.data;
if (model.buttonText){

    ; __line = 5
    ; __append("\n<button class=\"")
    ; __line = 6
    ; __append( buttonColorClass )
    ; __append("\">")
    ; __append(escapeFn( model.buttonText ))
    ; __append("</button>\n")
    ; __line = 7
    ; 
}

    ; __line = 9
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/mobile/button/button.ejs

}